/**
 * Created by Julio Perez on 9/20/2016.
 */

import routing from "./nav-links-legend.routes";
import NavLinksLegendController from "./nav-links-legend.controller";
import navLinksLegend from "./nav-links-legend.directive";
import navLinksLegendService from "./nav-links-legend.service";

export default angular
    .module("navLinksLegend", [
        navLinksLegend,
        navLinksLegendService
    ])
    .config(routing)
    .controller("NavLinksLegendController", NavLinksLegendController)
    .name;


// WEBPACK FOOTER //
// ./src/app/ui/nav-links-legend/index.js